import React from 'react';
import { View } from '@react-pdf/renderer';
import SectionRenderer, { POSITIONAL_SECTION_TYPES } from 'PDF/TemplateEngine/SectionRenderer';
import { TemplateColorsProvider } from 'PDF/TemplateEngine/TemplateColorsContext';

// Renderiza el cuerpo (secciones) de un template dentro de un PDF existente,
// SIN envolver en <Document>/<Page>. Pensado para migraciones parciales como
// PresupuestoV2/BudgetBody/BudgetRecord, donde el pipeline actual ya provee
// Document + Page + Header + Footer y sólo queremos inyectar las secciones
// low-code en lugar de los componentes hardcoded.
//
// Se filtran los types posicionales (portrait/header/footer) porque esos los
// monta el TemplateRenderer fuera del body (primera página / fixed per page).
// En partial-migration el body es todo lo que NO es posicional.
//
// El caller debe haber pre-cargado el template (ej. via useTemplateOrFallback)
// en el componente React padre del <PDFDownloadLink>, y pasar template + data
// + colors (los colores del tenant suelen venir de useTenantColors()).
export default function RenderTemplateBody({ template, data, config, colors }) {
  if (!template || !Array.isArray(template.sections)) return null;
  return (
    <TemplateColorsProvider colors={colors}>
      <View>
        {template.sections
          .filter((s) => s && s.visible !== false && !POSITIONAL_SECTION_TYPES.includes(s.type))
          .map((section) => (
            <SectionRenderer key={section.id} section={section} data={data} config={config} />
          ))}
      </View>
    </TemplateColorsProvider>
  );
}
